import { render, staticRenderFns } from "./PaginationGeneral.vue?vue&type=template&id=6a7bedbe&scoped=true&"
import script from "./PaginationGeneral.vue?vue&type=script&lang=js&"
export * from "./PaginationGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7bedbe",
  null
  
)

export default component.exports